var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15359_18632)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15359_18632",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75171 1.66663C4.83965 1.66663 1.66833 4.83794 1.66833 8.74996C1.66833 12.662 4.83965 15.8333 8.75171 15.8333C10.407 15.8333 11.9308 15.2646 13.1365 14.3133L17.7457 18.9225L18.9243 17.744L14.315 13.1348C15.2664 11.929 15.835 10.4054 15.835 8.74996C15.835 4.83794 12.6637 1.66663 8.75171 1.66663ZM3.335 8.74996C3.335 5.75842 5.76013 3.33329 8.75171 3.33329C11.7432 3.33329 14.1684 5.75842 14.1684 8.74996C14.1684 10.246 13.563 11.599 12.5818 12.5801C11.6007 13.5613 10.2477 14.1666 8.75171 14.1666C5.76013 14.1666 3.335 11.7415 3.335 8.74996Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15359_18632)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15359_18632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifyingGlass.9fe54e49a662f1abffb35b54b1d3eb22.svg";
export { ForwardRef as ReactComponent };